import { AddBlock as AddIcon } from '@clearkit/icons';
import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import paths from '~/lib/paths';
import { readableSingularSegmentType } from '~/lib/segments';

import styles from './styles.style';

function NewAudienceButton({ classes, className, type }) {
  return (
    <CKButton
      as={Link}
      className={classnames(className, classes.newAudienceButton)}
      leftIcon={<AddIcon className={classes.newAudienceButtonIcon} />}
      to={paths.segmentNew(type)}
      variant="bold"
      variantColor="blue"
    >
      New {readableSingularSegmentType(type)} audience
    </CKButton>
  );
}

NewAudienceButton.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['Company', 'Person']).isRequired,
};

export default withStyles(styles)(NewAudienceButton);
